import type { TooltipProps } from '@mantine/core';
import { Box, Tooltip } from '@mantine/core';
import { Switch } from '@repo/foundations';
import type { ReactNode } from 'react';
import { SettingsBlock } from '../SettingsBlock';

interface SettingsSwitchProps {
	title: string;
	description?: string | ReactNode;
	checked?: boolean;
	defaultChecked?: boolean;
	onChange: (checked: boolean) => void;
	disabled?: boolean;
	leftComponent?: ReactNode;
	fixedTooltipProps?: Omit<TooltipProps, 'children'>;
	icon?: ReactNode;
	testId?: string;
}

export function SettingsSwitch({
	title,
	description,
	checked,
	defaultChecked,
	onChange,
	disabled = false,
	leftComponent,
	fixedTooltipProps,
	testId,
}: SettingsSwitchProps) {
	return (
		<SettingsBlock
			title={title}
			description={description}
			leftComponent={leftComponent}
			testId={testId}
			rightComponent={
				<Box onClick={(e) => e.stopPropagation()}>
					<Tooltip
						label=""
						disabled={!fixedTooltipProps}
						{...fixedTooltipProps}
					>
						<Switch
							defaultChecked={defaultChecked}
							checked={checked}
							onChange={(event) => onChange(event.currentTarget.checked)}
							disabled={disabled}
						/>
					</Tooltip>
				</Box>
			}
		/>
	);
}
